"use client";

import { useEffect, useState } from "react";
import { GradientMenu } from "./gradient-menu";
import { LanguageToggle } from "./language-toggle";
import { Logo } from "./logo";
import { MobileMenu } from "./mobile-menu";

export function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-40 h-16 w-full transition-all duration-300 ${
        scrolled
          ? "bg-background/65 backdrop-blur-xl shadow-[0_1px_0_0_color-mix(in_oklch,var(--foreground)_8%,transparent),0_8px_24px_-12px_rgba(15,23,42,0.12)]"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-full w-full items-center justify-between gap-3 px-4 sm:px-6 lg:px-8">
        <Logo />

        {/* Nav — pill flou centré, desktop only. Inner highlight + soft drop
            shadow lui donnent un léger volume "verre dépoli" sans tomber dans
            le glass excessif. */}
        <div className="hidden md:flex">
          <div className="flex items-center rounded-full border border-border/50 bg-background/65 px-3 py-1.5 shadow-[inset_0_1px_0_rgba(255,255,255,0.65),0_8px_30px_-8px_rgba(15,23,42,0.10)] backdrop-blur-xl">
            <GradientMenu />
          </div>
        </div>

        <div className="flex items-center gap-1">
          <div className="hidden md:flex">
            <LanguageToggle />
          </div>
          <MobileMenu />
        </div>
      </div>
    </header>
  );
}
